<template>
    <footer class="section is-small is-primary has-text-centered is-long">
        <div class="container">
            <div class="columns">
                <div class="column is-5">
                    <h1 class="title">
                        <img src="@/assets/img/Logo-Reverse.png" alt="Logo" width="100">
                    </h1>
                    <div class="icon-list">
                        <p class="is-flex-tablet-only">
                            <a :href="link.link" class="button is-blue-reverse is-rounded is-outlined is-icon is-medium is-small-mobile-mod" target="_blank" v-for="link in medLink" :key="link.id">
                                <span class="icon is-small">
                                    <i :class="link.classIcon"></i>
                                </span>
                            </a>
                        </p>
                    </div>
                </div>
                <div class="column is-7 desc-hero-new">
                    <div class="subtitle is-size-6 is-size-7-mobile">
                        Handcrafted with &nbsp; <i class="fas fa-heart" style="color: #e2264d;"></i> &nbsp; by Me &nbsp; <i class="far fa-copyright"></i> duaribudelapanbelas
                    </div>
                    <div class="subtitle is-size-6 is-size-7-mobile">
                        Made with <a href="https://bulma.io/" class="link-footer">Bulma</a>,<a href="https://vuejs.org/" class="link-footer">VueJS</a>,<a href="https://typeitjs.com/" class="link-footer">TypeIt</a> & Many more.
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    computed: {
        medLink() {
            return this.$store.state.medLink
        }
    }
}
</script>

